import React from 'react';
import { X, Sparkles, CheckCircle, Calendar, Users } from 'lucide-react';

const MockVariationAnnouncementModal = ({ isOpen, onClose, onDontShowToday, onNavigate }) => {
  if (!isOpen) return null;

  const handleSubscribe = () => {
    onClose();
    if (onNavigate) {
      onNavigate('pricing');
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* 배경 오버레이 */}
      <div
        className="fixed inset-0 bg-black/60 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* 모달 콘텐츠 */}
      <div className="relative bg-white dark:bg-slate-800 rounded-2xl shadow-2xl max-w-md w-full overflow-hidden animate-in fade-in zoom-in duration-300">
        {/* 닫기 버튼 */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 z-10 p-1 rounded-full bg-white/20 hover:bg-white/30 transition-colors"
        >
          <X className="w-5 h-5 text-white" />
        </button>

        {/* 헤더 - 그라데이션 배경 */}
        <div className="bg-gradient-to-br from-orange-400 via-orange-500 to-amber-500 p-6 text-white text-center">
          <div className="flex justify-center mb-3">
            <div className="bg-white/20 p-3 rounded-full">
              <Sparkles className="w-8 h-8" />
            </div>
          </div>
          <h2 className="text-xl font-bold mb-2">모의고사 변형문제 안내</h2>
          <p className="text-orange-100 text-sm">
            블루북고를 사랑해 주셔서 감사합니다
          </p>
        </div>

        {/* 내용 */}
        <div className="p-6 space-y-4">
          {/* 가격 강조 */}
          <div className="bg-gradient-to-r from-orange-50 to-amber-50 dark:from-orange-900/20 dark:to-amber-900/20 rounded-xl p-4 text-center border border-orange-200 dark:border-orange-500/30">
            <p className="text-sm text-gray-600 dark:text-gray-400 mb-1">합리적인 가격</p>
            <p className="text-3xl font-bold text-orange-600 dark:text-orange-400">
              10,000원<span className="text-base font-normal text-gray-500">/1년</span>
            </p>
          </div>

          {/* 특징 목록 */}
          <div className="space-y-3">
            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center">
                <CheckCircle className="w-4 h-4 text-green-600 dark:text-green-400" />
              </div>
              <div>
                <p className="font-medium text-gray-800 dark:text-gray-200">모의고사 변형문제 전용 섹션</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">체계적으로 정리된 변형문제</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 bg-blue-100 dark:bg-blue-900/30 rounded-full flex items-center justify-center">
                <Users className="w-4 h-4 text-blue-600 dark:text-blue-400" />
              </div>
              <div>
                <p className="font-medium text-gray-800 dark:text-gray-200">고1 ~ 고3 전 학년 이용</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">모든 학년의 모의고사 변형문제 제공</p>
              </div>
            </div>

            <div className="flex items-start gap-3">
              <div className="flex-shrink-0 w-6 h-6 bg-purple-100 dark:bg-purple-900/30 rounded-full flex items-center justify-center">
                <Calendar className="w-4 h-4 text-purple-600 dark:text-purple-400" />
              </div>
              <div>
                <p className="font-medium text-gray-800 dark:text-gray-200">신규 모의고사 자동 추가</p>
                <p className="text-sm text-gray-500 dark:text-gray-400">새로운 모의고사 시행 후 빠르게 업데이트</p>
              </div>
            </div>
          </div>

          {/* 구독하기 버튼 */}
          <button
            onClick={handleSubscribe}
            className="w-full py-3 bg-gradient-to-r from-orange-500 to-amber-500 hover:from-orange-600 hover:to-amber-600 text-white font-bold rounded-xl transition-all transform hover:scale-[1.02] shadow-lg shadow-orange-500/25"
          >
            구독하러 가기
          </button>
        </div>

        {/* 하단 버튼 영역 */}
        <div className="flex border-t border-gray-200 dark:border-slate-700">
          <button
            onClick={onDontShowToday}
            className="flex-1 py-4 text-sm text-gray-500 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors border-r border-gray-200 dark:border-slate-700"
          >
            오늘 하루 그만 보기
          </button>
          <button
            onClick={onClose}
            className="flex-1 py-4 text-sm text-gray-700 dark:text-gray-300 font-medium hover:bg-gray-50 dark:hover:bg-slate-700/50 transition-colors"
          >
            닫기
          </button>
        </div>
      </div>
    </div>
  );
};

export default MockVariationAnnouncementModal;
